import "./OurStory.module.css";
import Header from "@/reusable_sections/Header";
import TheDhtpropertiesMission from "./sections/TheDhtpropertiesMission";
import OurCoreValues from "./sections/OurCoreValues";
import MeetTheInvestors from "./sections/MeetTheInvestors";
import CorporateFooter from "@/reusable_sections/Footer";
export default function OurStoryPage() {
  return <div>
      <Header />
      <TheDhtpropertiesMission />
      <OurCoreValues />
      <MeetTheInvestors />
      <CorporateFooter />
    </div>;
}